<template>
  <div class="edit-material">
    <el-button
      class="table_header_btn"
      size="medium"
      @click="edit"
      :disabled="!isEdit"
      >编辑素材</el-button
    >
    <!-- v-loading="loading" -->
    <el-drawer
      ref="drawer"
      :wrapperClosable="true"
      size="800px"
      title="编辑"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="edit-box">
        <div
          style="
            display: flex;
            justify-content: space-between;
            flex-direction: row;
          "
        >
          <el-alert
            :closable="false"
            title="提取会消耗提取次数,重新提取不会消耗次数"
            type="info"
            show-icon
          ></el-alert>
        </div>
        <div
          style="
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            margin-top: 20px;
          "
        >
          <el-tag style="align-self: center">关键词编辑</el-tag>
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="
              newKeywords = '';
              mutaddialogVisible = true;
            "
            >批量添加关键词</el-button
          >
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="mutgetKeywords()"
            v-loading="mutloading"
            >批量提取关键词</el-button
          >
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="
              oldkeyword = '';
              newkeyword = '';
              mutsetdialogVisible = true;
            "
            >批量替换关键词</el-button
          >
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="mutselectAll()"
            >一键全选关键词</el-button
          >
        </div>
        <div
          style="
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            margin-top: 20px;
          "
        >
          <el-tag style="align-self: center">素材标题编辑</el-tag>
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="
              newBiaoti = '';
              mutdialogVisible = true;
            "
            >批量添加素材标题</el-button
          >
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="
              oldKeyword = '';
              newKeyword = '';
              muttdialogVisible = true;
            "
            >批量替换素材标题</el-button
          >
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="mutUpperCase()"
            >首字母大写</el-button
          >
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="mutsetName()"
            >一键设为素材标题</el-button
          >
        </div>
        <div
          style="
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            margin-top: 20px;
          "
        >
          <el-tag style="align-self: center">冲突颜色编辑</el-tag>
          <el-button
            style="
              background-color: var(--style-color);
              color: white;
              margin-left: 20px;
            "
            @click="
              selectColor = [];
              colordialogVisible = true;
            "
            >批量编辑冲突颜色</el-button
          >
        </div>
        <div class="edit-item" v-for="(item, index) in dataList" :key="index">
          <el-image class="edit-img" fit="contain" :src="item.thumb"></el-image>
          <el-form
            style="width: 588px"
            size="small"
            :model="item"
            :rules="rules"
            @submit.native.prevent
          >
            <el-form-item label="素材标题:" label-width="90px" prop="name">
              <el-input
                style="width: 509px"
                v-model="item.name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="文件名:" label-width="90px" prop="file_name">
              <el-input
                style="width: 509px"
                v-model="item.file_name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="冲突颜色:" label-width="90px" prop="conflict_color">
              <el-select
                multiple filterable
                v-model="item.conflict_color"
                clearable
              >
                <el-option v-for="color in sysColorsList" :label="color.name" :value="color.name" :key="color.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键词:" label-width="90px">
              <div class="keyword-list">
                <el-checkbox-group v-model="item.selectKeywords">
                  <el-checkbox-button
                    v-for="keyword in item.keywords"
                    :label="keyword"
                    :key="keyword"
                    >{{ keyword }}</el-checkbox-button
                  >
                </el-checkbox-group>

                <el-button
                  icon="el-icon-plus"
                  @click="addKeywordBox(index)"
                  style="margin-bottom: 16px"
                  >添加关键词</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label-width="90px">
              <el-button @click="setName(index)">设为标题</el-button>
              <el-button
                v-if="item.is_pickup == false"
                style="background-color: var(--style-color); color: white"
                @click="getKeywords(item.img_url, index)"
                v-loading="item.loading"
                >提取关键词</el-button
              >
              <el-button
                v-else
                style="background-color: var(--style-color); color: white"
                @click="getKeywords(item.img_url, index)"
                v-loading="item.loading"
                >重新提取</el-button
              >
              <el-popconfirm
                style="margin: 0 12px"
                title="确定删除吗？"
                @confirm="removeMaterial(index)"
              >
                <el-button slot="reference">移除</el-button>
              </el-popconfirm>
              <el-button type="text" @click="selectAll(index)">全选</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 底部按钮 -->
        <div class="fixed-but">
          <el-button @click="cancelEditBox">取消</el-button>
          <el-button @click="confirmChanges" type="primary">确定</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 新建关键词弹窗 -->
    <el-dialog
      title="添加关键词"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form @submit.native.prevent>
        <el-form-item label="关键词:" label-width="60px">
          <el-input
            v-model="newKeywordList"
            placeholder="请输入关键词（一次只能输入一个）"
            @keyup.enter.native="addKeyword"
          ></el-input>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addKeyword">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="添加关键词"
      :visible.sync="mutaddialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form @submit.native.prevent>
        <el-form-item label="关键词:" label-width="60px">
          <el-input
            v-model="newKeywords"
            placeholder="请输入关键词（一次只能输入一个）"
            @keyup.enter.native="mutaddKeyword"
          ></el-input>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <el-button @click="mutaddialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="mutaddKeyword">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="批量添加素材标题"
      :visible.sync="mutdialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form @submit.native.prevent>
        <el-form-item label="" label-width="">
          <el-input
            v-model="newBiaoti"
            placeholder="请输入素材标题"
            @keyup.enter.native="mitbiaoti()"
          ></el-input>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <el-button @click="mutdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="mitbiaoti()">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="批量替换素材标题"
      :visible.sync="muttdialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form @submit.native.prevent>
        <el-form-item label="原关键词" label-width="100" :required="true">
          <el-input
            v-model="oldKeyword"
            placeholder="请输入"
            @keyup.enter.native="replaceBiaoti()"
          ></el-input>
        </el-form-item>
        <el-form-item label="新关键词" label-width="100">
          <el-input
            v-model="newKeyword"
            placeholder="请输入"
            @keyup.enter.native="replaceBiaoti()"
          ></el-input>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <el-button @click="muttdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="replaceBiaoti()">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="批量替换关键词"
      :visible.sync="mutsetdialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form @submit.native.prevent>
        <el-form-item label="原关键词" label-width="100" :required="true">
          <el-input
            v-model="oldkeyword"
            placeholder="请输入"
            @keyup.enter.native="replaceKeyword()"
          ></el-input>
        </el-form-item>
        <el-form-item label="新关键词" label-width="100">
          <el-input
            v-model="newkeyword"
            placeholder="请输入"
            @keyup.enter.native="replaceKeyword()"
          ></el-input>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <el-button @click="mutsetdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="replaceKeyword()">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="批量编辑冲突颜色"
      :visible.sync="colordialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form @submit.native.prevent>
        <el-form-item label="冲突颜色:" label-width="90px">
          <el-select
            multiple filterable
            v-model="selectColor"
            clearable
          >
            <el-option v-for="color in sysColorsList" :label="color.name" :value="color.name" :key="color.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <el-button @click="colordialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="mutColor">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { editFolder, getKeywords, colorList } from "network/material";
export default {
  name: "EditMaterial",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      dataList: [],
      sysColorsList: [],
      rules: {
        name: [
          { required: true, message: "素材名称不能为空", trigger: "change" },
        ],
      },
      dialogVisible: false,
      mutdialogVisible: false,
      muttdialogVisible: false,
      mutaddialogVisible: false,
      mutsetdialogVisible: false,
      colordialogVisible: false,
      selectColor:[],
      newBiaoti: "",
      oldKeyword: "",
      newKeyword: "",
      oldkeyword: "",
      newkeyword: "",
      newKeywords: "",
      // 新建关键词
      newKeywordList: [],
      //  已存在的关键词
      alreadyKeywordList: [],
      // 需要添加关键词的模块下标
      addKeywordIndex: -1,
      mutloading: false,
    };
  },
  created() {
    // this.getsysColorsList();
  },
  watch: {
    list() {
      let list = JSON.stringify(this.list);
      list = JSON.parse(list);
      this.dataList = list.map((item) => {
        // 用来存放每条素材中 已选中的关键词，最后提交用
        item.selectKeywords = [];
        item.loading = false;
        return item;
      });
    },
  },
  methods: {
    mutColor(){
      if (this.selectColor.length>0) {
        this.dataList.forEach((d) => {
          d.conflict_color = JSON.parse(JSON.stringify(this.selectColor));
        });
        this.colordialogVisible = false;
      } else {
        this.$message.warning("请选择冲突颜色");
      }
    },
    getsysColorsList(){
      this.sysColorsList=[];
      colorList().then((res)=>{
        if(res.data.code==1){
          this.sysColorsList=res.data.data;
        }
      })
    },
    edit() {
      this.drawer = true;
      this.$emit("updateMaterial");
    },
    handleClose(done) {
      this.$emit("update");
      done();
    },
    //  删除关键词
    deleteKeyword(index, keywordIndex) {
      this.dataList[index].keywords.splice(keywordIndex, 1);
    },
    //  显示添加关键词弹窗
    addKeywordBox(index) {
      this.newKeywordList = [];
      this.addKeywordIndex = index;
      this.dialogVisible = true;
    },
    mutaddKeyword() {
      if (this.newKeywords) {
        this.dataList.forEach((d) => {
          d.keywords.push(this.newKeywords);
        });
        this.mutaddialogVisible = false;
      } else {
        this.$message.warning("请输入关键词");
      }
    },
    //   添加关键词
    addKeyword() {
      this.dataList[this.addKeywordIndex].keywords.push(this.newKeywordList);
      this.dialogVisible = false;
    },
    //   添加关键词
    getKeywords(url, index) {
      this.dataList[index].loading = true;
      this.dataList[index].selectKeywords = [];
      getKeywords(url).then((res) => {
        if (res.data.code == 1) {
          res.data.data.forEach((item) => {
            if (this.dataList[index].keywords.indexOf(item) == -1) {
              this.dataList[index].keywords.push(item);
            }
          });
          const obj = this.dataList.map((item) => {
            return {
              id: item.id,
              name: item.name,
              keywords: item.keywords,
            };
          });
          editFolder(JSON.stringify(obj)).then((res) => {
            if (res.data.code == 1) {
            }
            this.messageBox(res);
          });
          this.dataList[index].is_pickup = true;
        }
        this.dataList[index].loading = false;
        this.messageBox(res);
      });
    },
    mitbiaoti() {
      if (this.newBiaoti) {
        this.dataList.forEach((d) => {
          d.name = this.newBiaoti;
        });
        this.mutdialogVisible = false;
      } else {
        this.$message.warning("请输入标题");
      }
    },
    replaceBiaoti() {
      if (this.oldKeyword) {
        this.dataList.forEach((d) => {
          d.name = d.name.replace(
            new RegExp(this.oldKeyword, "gm"),
            this.newKeyword
          );
        });
        this.muttdialogVisible = false;
      } else {
        this.$message.warning("请输入原关键词");
      }
    },
    replaceKeyword() {
      if (this.oldkeyword) {
        this.dataList.forEach((d) => {
          d.keywords.forEach((k, i) => {
            if (k == this.oldkeyword) {
              d.keywords[i] = JSON.parse(JSON.stringify(this.newkeyword));
            }
          });
        });
        this.mutsetdialogVisible = false;
      } else {
        this.$message.warning("请输入原关键词");
      }
    },
    mutUpperCase() {
      this.dataList.forEach((d) => {
        d.name = d.name
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      });
    },
    mutgetKeywords() {
      this.mutloading = true;
      let num = this.dataList.length;
      this.dataList.forEach((d, index) => {
        this.dataList[index].loading = true;
        getKeywords(d.img_url).then((res) => {
          if (res.data.code == 1) {
            res.data.data.forEach((item) => {
              if (this.dataList[index].keywords.indexOf(item) == -1) {
                this.dataList[index].keywords.push(item);
              }
            });
            const obj = this.dataList.map((item) => {
              return {
                id: item.id,
                name: item.name,
                keywords: item.keywords,
              };
            });
            editFolder(JSON.stringify(obj)).then((res) => {
              num--;
              if (num == 0) {
                this.mutloading = false;
              }
              if (res.data.code == 1) {
              }
              this.messageBox(res);
            });
            this.dataList[index].is_pickup = true;
          } else {
            num--;
            if (num == 0) {
              this.mutloading = false;
            }
          }
          this.dataList[index].loading = false;
          this.messageBox(res);
        });
      });
    },
    //  设置素材名称
    setName(index) {
      if (this.dataList[index].selectKeywords.length > 0) {
        this.dataList[index].name = "";
        this.dataList[index].selectKeywords.forEach((item) => {
          this.dataList[index].name += `${item} `;
        });
      } else {
        this.$message("请至少选中一个关键词");
      }
    },
    mutsetName() {
      this.dataList.forEach((d) => {
        if (d.selectKeywords.length > 0) {
          d.name = "";
          d.selectKeywords.forEach((item) => {
            d.name += `${item} `;
          });
        }
      });
    },
    //    全选关键词
    selectAll(index) {
      this.dataList[index].selectKeywords = JSON.parse(
        JSON.stringify(this.dataList[index].keywords)
      );
    },
    mutselectAll() {
      this.dataList.forEach((d) => {
        d.selectKeywords = JSON.parse(JSON.stringify(d.keywords));
      });
    },
    //   移除编辑块
    removeMaterial(index) {
      if (this.dataList[index].selectKeywords.length > 0) {
        this.dataList[index].selectKeywords.forEach((item) => {
          if (this.dataList[index].keywords.indexOf(item) != -1) {
            this.dataList[index].keywords.splice(
              this.dataList[index].keywords.indexOf(item),
              1
            );
          }
        });
        this.dataList[index].selectKeywords = [];
      } else {
        this.$message("请至少选中一个关键词");
      }
    },
    /* 取消编辑弹窗 */
    cancelEditBox() {
      //   取消弹窗时向外发射一个事件，用于更新数据
      this.$emit("update");
      this.$refs.drawer.hide();
    },
    /* 确认按钮 */
    confirmChanges() {
      const obj = this.dataList.map((item) => {
        return {
          id: item.id,
          name: item.name,
          file_name: item.file_name,
          keywords: item.keywords,
          conflict_color:item.conflict_color.length>0?item.conflict_color.join(','):'',
        };
      });
      this.editFolder(obj);
    },
    editFolder(sourceList) {
      editFolder(JSON.stringify(sourceList)).then((res) => {
        if (res.data.code == 1) {
          this.$emit("update");
          this.$refs.drawer.hide();
        }
        this.messageBox(res);
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-image__inner {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAIAAABLixI0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDE5LTEwLTIyVDE2OjMxOjQ5KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHN0RXZ0OndoZW49IjIwMTktMTAtMjJUMTY6MzE6NDkrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6l0qErAAAASklEQVQ4je3TwQkAMQhEUWdJYZZuW4JgOohzCSxk5vx5B0F0t02LiLExs4+JyMmS9aK1yF+jLLJz97H5671kybppsT9UVZl5CABsVSkOV58tY+kAAAAASUVORK5CYII=);
  background-repeat: repeat;
  background-position: center;
}


::v-deep .el-checkbox-button {
  margin-right: 10px;
  margin-bottom: 10px;
}

::v-deep .el-checkbox-button__inner {
  border-left: 1px solid #DCDFE6;
  border-radius: 4px !important;
}

.edit-material {
  // margin-right: 24px;
  display: inline-block;
  .table_header_btn {
    margin-right: 24px;
    font-size: 14px;
    border-radius: 4px;
    background: var(--work-color);
    color: #ffffff;
    &.is-disabled {
      filter: opacity(0.6);
    }
  }
}

.edit-box {
  position: relative;
  padding: 24px 24px 100px 24px;
  border-top: 1px solid #f0f0f0;

  .fixed-but {
    position: fixed;
    bottom: 0px;
    padding: 30px 24px;
    background-color: #fff;
    width: 760px;
    text-align: right;
  }

  ::v-deep .el-checkbox-button {
    margin-right: 10px;
  }
}

.edit-item {
  display: flex;
  margin-top: 24px;
  width: 100%;
  border-bottom: 1px solid #f0f0f0;
}

.edit-img {
  margin-right: 24px;
  width: 130px;
  height: 130px;
}

.keyword-list {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  top: 4px;

  .keyword-item {
    margin-bottom: 16px;
    user-select: none;
    border-radius: 10px;
    padding: 0 12px;
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    height: 30px;
    font-size: 12px;
    color: #606266;
    margin-right: 12px;
    background-color: #fff;
    cursor: pointer;

    i {
      margin-left: 6px;
      color: #999;
      font-size: 16px;
    }
  }

  .selectedKeyword {
    // background-color: $--color-primary;
    color: #fff;

    i {
      margin-left: 6px;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
